




























































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import SepSvc from "@/services/bridgingVclaim/SEP";
import { appModule } from "@/store/modules/app";

@Component({})
export default class UpdateTanggalPulangModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly noSep!: string;

  statusPulang = "";
  noSuratMeninggal = "";
  tglMeninggal = "";
  tglPulang = "";
  noLapPolisiManual = "";
  user = "user ws";

  saving = false;
  showTglMeninggal = false;
  showTglPulang = false;
  statusPulangOpts = [
    { text: "Atas Persetujuan Dokter", value: "1" },
    { text: "Atas Permintaan Sendiri", value: "3" },
    { text: "Meninggal", value: "4" },
    { text: "Lain-lain", value: "5" }
  ];

  clearForm() {
    this.statusPulang = "";
    this.noSuratMeninggal = "";
    this.tglMeninggal = "";
    this.tglPulang = "";
    this.noLapPolisiManual = "";
  }

  get reqData() {
    return {
      noSep: this.noSep,
      statusPulang: this.statusPulang,
      noSuratMeninggal: this.noSuratMeninggal,
      tglMeninggal: this.tglMeninggal,
      tglPulang: this.tglPulang,
      noLPManual: this.noLapPolisiManual,
      user: this.user
    };
  }

  get showFieldMeninggal() {
    return this.statusPulang == "4";
  }

  @Watch("showFieldMeninggal")
  changeShowFieldMeninggal(val) {
    if (!val) {
      this.tglMeninggal = "";
      this.noSuratMeninggal = "";
    }
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      SepSvc.updateTglPulang(this.reqData)
        .then(resp => {
          if (resp.status == 1) {
            appModule.NoticeDelay("Berhasil Update Tanggal Pulang");
            alert("Berhasil Update Tanggal Pulang");

            this.close();
          } else {
            appModule.sendErrorAlert(resp.message);
          }
        })
        .catch(resp => {
          appModule.sendErrorAlert(resp.message);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.$emit("close");

    this.clearForm();
  }

  tglFormattedMomentjs(val) {
    return val ? moment(val).format("DD MMMM YYYY") : "";
  }
}
